export default __webpack_public_path__ + "static/media/3_transparencia.c60a156a.svg";